import { httpsCallable, type HttpsCallableResult } from 'firebase/functions';

import { functions } from '@/services/firebase';

export class CallableError extends Error {
  constructor(
    message: string,
    public readonly code?: string,
  ) {
    super(message);
    this.name = 'CallableError';
  }
}

export async function callFunction<TPayload, TResult>(name: string, payload: TPayload): Promise<TResult> {
  const fn = httpsCallable<TPayload, TResult>(functions, name);
  try {
    const result: HttpsCallableResult<TResult> = await fn(payload);
    return result.data;
  } catch (err) {
    const message = err instanceof Error ? err.message : 'Unknown error';
    const code = err && typeof err === 'object' && 'code' in err ? String((err as { code: unknown }).code) : undefined;
    throw new CallableError(message, code);
  }
}
